import React from 'react';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
//import Container from 'components/Container';
import Link from '@mui/material/Link';
import Box from '@mui/material/Box';
import FileUploadViewer from 'views/NotFoundCover/FileUploadViewer';
import { useFormik } from 'formik';
import { FormControlLabel } from '@mui/material';

import Button from '@mui/material/Button';
import { Checkbox } from '@mui/material';

const Description = ({ initialState, thirdState, handleCurrentStep }) => {
  const mock = [
    {
      name: '1. Student Photo',
      email: '',
      title: '',
      status: '',
      href: '',
    },
    {
      name: '2. Birth Certificate',
      email: '',
      title: '',
      status: '',
      href: '',
    },
    {
      name: '3. Aadhar/Passport',
      email: '',
      title: '',
      status: '',
      href: '',
    },
    {
      name: '4. Father Aadhar',
      email: '',
      title: '',
      status: '',
      href: '',
    },
    {
      name: '5. Mother Aadhar',
      email: '',
      title: '',
      status: '',
      href: '',
    },
  ];

  if (initialState) {
    mock[0].href = initialState.photo;
    mock[0].fileName = initialState.fileName;
    mock[0].imageUrl = initialState.imagePreviewUrl;

    mock[1].href = thirdState.photoAadhar;
    mock[1].fileName = thirdState.photoAadharFileName;
    mock[1].imageUrl = thirdState.photoAadharImagePreviewUrl;

    mock[2].href = thirdState.photoBirth;
    mock[2].fileName = thirdState.photoBirthFileName;
    mock[2].imageUrl = thirdState.photoBirthImagePreviewUrl;

    mock[3].href = thirdState.photoFatherAadhar;
    mock[3].fileName = thirdState.photoFatherAadharFileName;
    mock[3].imageUrl = thirdState.photoFatherAadharImagePreviewUrl;

    mock[4].href = thirdState.photoMotherAadhar;
    mock[4].fileName = thirdState.photoMotherAadharFileName;
    mock[4].imageUrl = thirdState.photoMotherAadharImagePreviewUrl;
  }

  let isDisabled = true;

  const formik = useFormik({
    initialValues: { agree: false },
  });

  if (formik.values.agree === true) {
    isDisabled = false;
  }

  return (
    <Box>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 700 }}>
          <TableHead sx={{ bgcolor: '#377dff' }}>
            <TableRow>
              <TableCell>
                {/* <Typography
             
              fontWeight={700}
              // sx={{ textTransform: 'uppercase' }}
            >
            </Typography> */}
              </TableCell>
              <TableCell>
                <Typography
                  variant={'caption'}
                  color={'white'}
                  fontWeight={700}
                  sx={{ textTransform: 'uppercase' }}
                  marginLeft={25}
                >
                  Documents
                </Typography>
              </TableCell>
              <TableCell>
                <Typography
                  variant={'caption'}
                  fontWeight={700}
                  sx={{ textTransform: 'uppercase' }}
                ></Typography>
              </TableCell>
              <TableCell>
                <Typography
                  variant={'caption'}
                  fontWeight={700}
                  sx={{ textTransform: 'uppercase' }}
                ></Typography>
              </TableCell>
              <TableCell>
                <Typography
                  variant={'caption'}
                  fontWeight={700}
                  sx={{ textTransform: 'uppercase' }}
                ></Typography>
              </TableCell>
              <TableCell />
            </TableRow>
          </TableHead>
          <TableBody>
            {mock.map((item, i) => (
              <TableRow
                key={i}
                sx={{
                  '&:last-child td, &:last-child th': { border: 0 },
                }}
              >
                <TableCell component="th" scope="row">
                  <Typography variant={'subtitle2'} fontWeight={700}>
                    {item.name}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography color={'text.secondary'} variant={'subtitle2'}>
                    {item.email}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography color={'text.secondary'} variant={'subtitle2'}>
                    {item.title}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography variant={'caption'} fontWeight={700}>
                    {item.status}
                  </Typography>

                  <div id="photoFatherAadhar">
                    <FileUploadViewer
                      key={`image-${i}`}
                      info={`image-${i}`}
                      id={`image-${i}`}
                      file={mock[i].href}
                      uploadNotRequired={true}
                      fileName={mock[i].fileName}
                      imagePreviewUrl={mock[i].imageUrl}
                    />
                  </div>
                </TableCell>
                <TableCell>
                  <Typography color={'text.secondary'} variant={'subtitle2'}>
                    {item.role}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography
                    color={'primary'}
                    variant={'subtitle2'}
                    fontWeight={700}
                    sx={{ cursor: 'pointer' }}
                  ></Typography>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <br />
      <Box>
        <Typography color="primary">
          <strong>DECLARATION BY PARENT/GUARDIAN</strong>
          <br />
        </Typography>

        <Typography>
          I have{' '}
          <Link href={'not-found'} underline="none">
            read the rules and regulations
          </Link>{' '}
          of NPS YPR and I fully agree to abide by them so long as my child is a
          student at this school if selected.
        </Typography>
        <Typography>
          I hereby declare that the information furnished above is true and
          correct to the best of my knowledge and I undertake to inform you of
          any changes therein, immediately.
        </Typography>
        <Typography>
          <strong>
            Application once submitted connot be edited. Kindly note your
            application no : YPR/NUR/2022/00981
          </strong>
        </Typography>

        <FormControlLabel
          control={
            <Checkbox
              id={'agree'}
              name={'agree'}
              color="primary"
              defaultChecked={formik.values.agree}
              onChange={formik.handleChange}
              
            />
          }
          label="I Agree"
        />

        <br />
        <Box
          component={Button}
          variant="contained"
          size="large"
          height={54}
          marginTop={{ xs: 8, sm: 9 }}
          marginLeft={{ sm: 35 }}

          // href='/startup'
        >
          <span onClick={() => handleCurrentStep(1)}> Edit Application</span>
        </Box>

        <Box
          component={Button}
          variant="contained"
          bgcolor="primary"
          size="large"
          height={54}
          //href={""}
          marginTop={{ xs: 8, sm: 9 }}
          marginLeft={{ sm: 4 }}
          disabled={isDisabled}
        >
          <span onClick={() => handleCurrentStep(5)}> Submit</span>
        </Box>
      </Box>
    </Box>
  );
};

export default Description;
